export default {
  FLAT: { label: "Flat", value: "FLAT" },
  DOUBLE: { label: "Double Occupancy", value: "DOUBLE" },
  PP: { label: "Per Person", value: "PP" },
  PD: { label: "Per Day", value: "PD" },
  PG: { label: "Per Group", value: "PG" },
  PROOM: { label: "Per Room", value: "PROOM" },
};
